export const fakeRequest = (timeout: number, isReject: boolean = false) =>
  new Promise<void>((resolve, reject) => {
    setTimeout(() => {
      if (isReject) reject();
      else resolve();
    }, timeout);
  });
